import { Target, HeartHandshake, Eye, Swords } from "lucide-react";
import { Reveal } from "./Reveal";
import SectionHeading from "./SectionHeading";
import { SOBRE_IMAGE } from "../data/siteData";

const PILARES = [
  {
    icon: Target,
    titulo: "Objetivo",
    texto: "Preparar atletas de futebol nos aspectos tático, físico e técnico para que possam obter sucesso em clubes no Brasil e no exterior como jogadores de futebol profissional.",
  },
  {
    icon: HeartHandshake,
    titulo: "Missão",
    texto: "Proporcionar uma oportunidade de bem-estar social, cultural e esportivo aos atletas que enxergam o futebol como possibilidade de profissão e disciplina de vida.",
  },
  {
    icon: Eye,
    titulo: "Visão",
    texto: "Tornar-se referência em treinamento de alto rendimento de futebol no Brasil e no exterior.",
  },
];

const Sobre = () => (
  <section id="sobre" data-testid="sobre-section" className="relative bg-night py-20 md:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="A escola"
        title="Sobre a Soccer Trainer"
        lead="A Soccer Trainer nasceu em 2011 em Patos de Minas com o propósito de formar atletas e cidadãos por meio do futebol. Comandada pelo professor Thales Affá, ex-atleta profissional, a escola oferece treinamentos técnicos, táticos e físicos para crianças e adolescentes, do iniciante ao alto rendimento."
      />

      <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-2 rounded-3xl border-2 border-gold/40" aria-hidden="true" />
            <img
              src={SOBRE_IMAGE}
              alt="Atletas da Soccer Trainer treinando no gramado"
              loading="lazy"
              className="relative aspect-[4/3] w-full rounded-3xl object-cover"
            />
          </div>
        </Reveal>
        <div className="grid gap-5 lg:col-span-7">
          {PILARES.map((p, i) => (
            <Reveal key={p.titulo} delay={i * 0.1}>
              <div
                data-testid={`pilar-${p.titulo.toLowerCase()}`}
                className="flex gap-5 rounded-2xl border border-white/10 bg-navy/60 p-6 transition-colors duration-300 hover:border-lawn/40"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-royal/60">
                  <p.icon size={24} className="text-gold" strokeWidth={1.9} />
                </div>
                <div>
                  <h3 className="font-display text-2xl uppercase tracking-wide text-lawn">{p.titulo}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/75">{p.texto}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.1} className="mt-16">
        <div
          data-testid="sobre-destaque-amistosos"
          className="flex flex-col items-start gap-4 rounded-2xl border border-gold/30 bg-gradient-to-r from-royal/50 to-navy p-6 sm:flex-row sm:items-center md:p-8"
        >
          <Swords size={36} className="shrink-0 text-gold" strokeWidth={1.8} />
          <p className="text-sm leading-relaxed text-white/85 sm:text-base">
            Além das aulas semanais, a escola promove{" "}
            <strong className="text-gold">desafios entre os alunos</strong> e{" "}
            <strong className="text-gold">amistosos regulares contra outras equipes</strong>,
            para que os atletas coloquem em prática o que aprendem.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Sobre;
